export default __webpack_public_path__ + "locales/el-GR/VersionHistory.json?hash=9d9e7fb82e47456ceace5db33f867785";